import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ADD_TOAST_MESSAGE } from 'Redux/Enums/Contracts.Globals.Enums';
import MenuButton from 'Common/MenuButton/MenuButton';
import MenuPage from 'Common/Navigation/MenuPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFunnelDollar, faUsersCog, faFileSignature } from '@fortawesome/free-solid-svg-icons';

const Menu = ({ title, onChange }) => {
    const isSupervisor = useSelector(state => state.user.isSupervisor);
    const dispatch = useDispatch();

    return (
        <MenuPage title={title}>
            <MenuButton
                title="Step 1: Template Configuration"
				icon={() => <FontAwesomeIcon icon={faFileSignature} size="8x" />}
                width="80%"
                onClick={handleTemplateConfigClick}
            />
            <MenuButton
                title="Step 2: Appointment Management"
				icon={() => <FontAwesomeIcon icon={faUsersCog} size="8x" />}
                width="80%"
                onClick={() => onChange('appointments')}
            />
            <MenuButton
                title="Step 3: Fees"
				icon={() => <FontAwesomeIcon icon={faFunnelDollar} size="8x" />}
                width="80%"
                onClick={() => onChange('fees')}
            />
        </MenuPage>	
    );

    function handleTemplateConfigClick() {
        if (isSupervisor) {
            onChange('templates');
        } else {
            dispatch({
                type: ADD_TOAST_MESSAGE,
                payload: { severity: 'warning', message: 'No Access for Template Configuration Details. Please contact Administrator.' }
            });
        }
    }
};

export default Menu;
